import { render, staticRenderFns } from "./MenuNavbar-comp-left.vue?vue&type=template&id=60499c1c&"
import script from "./MenuNavbar-comp-left.vue?vue&type=script&lang=js&"
export * from "./MenuNavbar-comp-left.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavbar-comp-left.vue?vue&type=style&index=0&id=60499c1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports